import React, { ChangeEvent, useCallback, useState ,useEffect} from 'react';
import { useLocation , Link ,useNavigate} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MembPasswdChngApi from 'Apis/MembPasswdChngApi';
import"Assets/css/MembFind.css";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import FindPwEmlAthnNoSendApi from 'Apis/FindPwEmlAthnNoSendApi';
import useRecaptcha from 'Utils/useRecaptcha';
import { es } from 'date-fns/locale';
import ApiError from 'Utils/ApiError';
import ApiResultModal from 'Components/ApiResultModal';

const MembPasswdChngRsltUi = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let membId:string = location.state?.membId;
    let idntMthdCd:string = location.state?.idntMthdCd;
    const {isLoading,error,data: langData}:any = UseLangLstQuery( );
    const [passwdInputVal,setPasswdInputVal] = useState("");
    const [passwdChkVal,setPasswdChkVal] = useState("");
    const [passwdRsltVal,setPasswdRsltVal] = useState<string>("");
    let isAuthenticated: boolean = location.state?.isAuthenticated || false;
    // alert setting
    const [passwdAlertTxt,setPasswdAlertTxt] = useState("");
    const [passwdAlertState,setPasswdAlertState] = useState("N");
    const [passwdChkAlertTxt,setPasswdChkAlertTxt] = useState("");
    const [passwdChkAlertState,setPasswdChkAlertState] = useState("N");
    const { getToken } = useRecaptcha();
    const [emlAthnCdValState,setEmlAthnCdValState]=useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const passWdRole = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@\$%\^&\*_\~\-])[A-Za-z\d!@\$%\^&\*_\~\-]{8,30}$/;
    const PasswdInputHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setPasswdRsltVal(""); // 비밀번호 입력 시 결과값 초기화
        const nextPasswd = event.currentTarget.value;
        setPasswdInputVal(nextPasswd);

        // 액션 시 기존 라벨 초기화
        setPasswdAlertState("N");
        setPasswdAlertTxt("");
        setPasswdChkAlertState("N");
        setPasswdChkAlertTxt("");

        // 비밀번호 필드 라벨 표시
        if (nextPasswd.length === 0) {
            setPasswdAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_DESC_00);
        } else if (!passWdRole.test(nextPasswd)) {
            setPasswdAlertTxt(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
        }
        
        // 비밀번호가 변경되면 비밀번호 확인 상태도 초기화
        if(passwdChkVal.length > 0) {
            if(nextPasswd !== passwdChkVal) {
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_00);
            } else {
                setPasswdChkAlertState("Y");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_01);
            }
        }
    }
    const EmlAthnCdInputHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setEmlAthnCdValState(event.currentTarget.value);
    }
    const PasswdChkHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setPasswdRsltVal(""); // 비밀번호 확인 입력 시 결과값 초기화
        const nextPasswdChk = event.currentTarget.value;
        setPasswdChkVal(nextPasswdChk);

        // 액션 시 확인 라벨 초기화
        setPasswdChkAlertState("N");
        setPasswdChkAlertTxt("");
        
        // 비밀번호 확인 필드가 비워진 경우
        if(nextPasswdChk.length === 0) {
            setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_DESC_00);
            //비밀번호를 입력해주세요.
            return;
        }
        
        if(!passWdRole.test(passwdInputVal)){
            setPasswdChkAlertTxt(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
            //8~30자 이내 영문+숫자+특수  문자( !,@,$,%,^,&,*,_,~,- ) 조합으로 입력해주세요.
        }else {
            if(passwdInputVal.length !=0 && passwdInputVal == nextPasswdChk ) {
                setPasswdChkAlertState("Y");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_01);
                //입력한 비밀번호가 일치합니다.
            }
            else if (passwdInputVal.length ==0) {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_DESC_00);
                //비밀번호를 입력해주세요.
            }
            else {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_00);
                //입력한 비밀번호가 일치하지 않습니다.
            }
        }
    }
    const PasswdChkFunc = () => {
        // 액션 시 확인 라벨 초기화
        setPasswdChkAlertState("N");
        setPasswdChkAlertTxt("");

        if(!passWdRole.test(passwdInputVal)){
            
            setPasswdChkAlertTxt(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
            //8~30자 이내 영문+숫자+특수  문자( !,@,$,%,^,&,*,_,~,- ) 조합으로 입력해주세요.

        }else {
            if(passwdInputVal.length !=0 && passwdInputVal == passwdChkVal ) {
                setPasswdChkAlertState("Y");
                setPasswdRsltVal(passwdChkVal);
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_01);
                // 입력한 비밀번호가 일치합니다.
            }
            else if (passwdInputVal.length ==0) {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_DESC_00);
                //비밀번호를 입력해주세요.
            }
            else {
                setPasswdChkAlertState("N");
                setPasswdRsltVal("");
                setPasswdChkAlertTxt(langData.MEMB_JOIN_PASSWD_INPUT_LBL_00);
                // 입력한 비밀번호가 일치하지 않습니다.
            }
        }
    }
    useEffect(() => {
        setPasswdAlertTxt(langData && langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
        setPasswdAlertState("N");
        setPasswdChkAlertTxt("");
        setPasswdChkAlertState("N");
    }, [langData]);

    useEffect(() => {
        const sendFindPw = async () => {
            if (!isAuthenticated && idntMthdCd === "EML") {
                try {
                    const token = await getToken('findpw');
                    const resp = await FindPwEmlAthnNoSendApi("PWD_RSET_FIND", membId, token);
                    switch(resp.apiHdr.code) {
                        case "ATHN0000":
                            break;
                        case "ATHN2000" :
                            openResultModal(
                                langData&&langData.MEMB_FIND_PASSWD_EML_ATHN_NO_SEND_ERROR_00,
                                () => navigate("/MembFindPw")
                            );
                            break;
                        default:
                            ApiError(langData,resp.apiHdr.code);
                            break;
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('reCAPTCHA token failed', e);
                }
            }
        };
        void sendFindPw();
    }, [isAuthenticated, idntMthdCd, membId]);
    const passWdChngFunc = (loginId:string,passWd:string,emlAthnCd:string|null)=> {
        if(passWd === ""||passWd === null||!passWdRole.test(passWd)) {
            openResultModal(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
            return false;
        }
        (async () => {
            try {
                const token = await getToken('memb_passwd_chng');
                const resp = await MembPasswdChngApi(loginId, passWd, token, idntMthdCd, emlAthnCd);
                if(resp.apiHdr.code=="ATHN2100") {
                    openResultModal(
                        langData&&langData.MEMB_JOIN_EML_ATHN_ERROR_00,
                        () => navigate("/MembFindPw")
                    );
                }
                else if(resp.apiHdr.code=="MEMB0000") {
                    openResultModal(
                        langData&&langData.MEMB_FIND_PASSWD_RSLT_LPOP_00,
                        () => navigate("/Login")
                    );
                }
                else{
                    ApiError(langData,resp.apiHdr.code);
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('reCAPTCHA token failed', e);
            }
        })();
    }
    return(
        <div className="loginInputWrap">
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MEMB_FIND_PASSWD_MAIN_TITL_00}`}</title>
        </Helmet>
        <Link to="/Login" className='loginBackBtn'>
            <img src={process.env.PUBLIC_URL + '/images/login/backIcon.png'} alt="" />
        </Link>
        <div className="membJoinForm">
            <div className="membFindTitl membFindRsltTitl">
                <h1>{langData&&langData.MEMB_FIND_PASSWD_RSLT_TITL_00}</h1>
            </div>
            <div className="membFindRsltTxtWrap membFindPwRsltTxtWrap BgR">
                <img className="membFindRsltImg" src={process.env.PUBLIC_URL+ "/images/warningIcon.png"} alt="" />
                <p>
                    {langData&&langData.MEMB_FIND_PASSWD_RSLT_DESC_00}
                </p>
            </div>
            <div className="membFindRsltUl membFindPwRsltUl">
                {idntMthdCd&&idntMthdCd != "MBP" && !isAuthenticated? 
                <ul>
                    <li >
                        <div className="loginIdInfo margin0A">
                            <p>{langData&&langData.MEMB_JOIN_ID_MAIN_TITL_00}</p>
                            <p className="colGreen">{membId}</p>
                        </div>
                    </li>
                    <li>
                        <div className="loginIdInfo">
                            <p>{langData&&langData.FIND_ATHN_NO_INPUT_TITL_00}</p>
                        </div>
                        <input type="text" onChange={EmlAthnCdInputHandler} placeholder="인증번호를 입력해주세요"/>
                    </li>
                </ul>:
                    <></>
                }
                <ul className="pt30">
                    <li>
                        <div className="loginIdInfo">
                            <p>{langData&&langData.MEMB_JOIN_PASSWD_MAIN_TITL_00}</p>
                            {/* 비밀번호 */}
                        </div>
                        <input type="password" name='PasswdInput' className='membJoinFormInput' placeholder={`${langData&&langData.MEMB_JOIN_PASSWD_INPUT_DESC_00}`} id='passwdInput' onChange={PasswdInputHandler}/>
                        {/* 비밀번호를 입력해주세요. */}
                        <span className={passwdAlertState == "Y"?"joinInputDesc colGreen":"joinInputDesc"}>{passwdAlertTxt}</span>
                    </li>
                    <li>
                        <div className="loginIdInfo">
                            <p>{langData&&langData.MEMB_JOIN_PASSWD_CHK_TITL_00}</p>
                            {/* 비밀번호 확인 */}
                        </div>
                        <input type="password" name='PasswdInput' className='membJoinFormInput' placeholder={`${langData&&langData.MEMB_JOIN_PASSWD_CHK_DESC_00}`} id='passwdChkInput' onChange={PasswdChkHandler} onBlur={() => PasswdChkFunc()}/>
                        {/*비밀번호를 다시 한번 입력해주세요.  */}
                        <span className={passwdChkAlertState == "Y"?"joinInputDesc colGreen":"joinInputDesc"}>{passwdChkAlertTxt}</span>
                    </li>
                </ul>
                <div className="nextBtnWrap">
                    <button onClick={()=>passWdChngFunc(membId,passwdRsltVal,emlAthnCdValState)} className="loginBtn" >
                        {langData&&langData.MEMB_FIND_PASSWD_CHNG_BTN_00}
                    </button>
                </div>
            </div>
        </div>
        {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
        </div>
    )
}

export default MembPasswdChngRsltUi;